//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum, NewsPostIconEnum } from './Enums';

export class NewsUpdateItem extends ItemBase {
    Title?: string | null;
    BodyHTML?: string | null;
    Category?: string | null;
    Color?: EventColorEnum;
    Icon?: NewsPostIconEnum;
    PublishDate?: string;
    IsSticky?: boolean;
    TeacherID?: string | null;
    ShowOnStudentPortal?: boolean;
    ShowOnTeacherPortal?: boolean;
    ShowOnBlog?: boolean;

    constructor(initializer?: Partial<NewsUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "NewsUpdateItem";
}
